<script lang="ts" setup>
import { onMounted, reactive, ref, watch } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "./EditComponentStatic";
import { useRegisterValidation } from "@/components/EditorValidator";
const emitFn = defineEmits<CommonEditControlEmits>();

const props = defineProps<EditControlProps>();
const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
var uiData = reactive(ui);

config.validate = validate;
useRegisterValidation({ config });

let disabledText = ref<string>("");
let currentVal = ref<any>();
let text1 = ref("offen");
let text2 = ref("bewilligt");
let text3 = ref("abgelehnt");

let value1 = ref("");
let value2 = ref("Ja");
let value3 = ref("Nein");
let aic1 = ref("");
let aic2 = ref("0");
let aic3 = ref("1");
let error: boolean = false;
let initialized: boolean = false;
// watch(
//   () => uiData.disabled,
//   (disabled) => {
//     if (disabled) {
//       disabledText.value = disabledValue();
//     }
//   }
// );
onMounted(() => {
  mounted(uiData, props, config);
  let val = config.initValue;
  const column = config.column;
  if (column && column.meta && column.meta.combo && column.meta.combo.length === 3) {
    const combo = column.meta.combo;
    text1.value = combo[0].bezeichnung ?? "text1";
    text2.value = combo[1].bezeichnung ?? "text2";
    text3.value = combo[2].bezeichnung ?? "text3";

    value1.value = combo[0].nr;
    value2.value = combo[1].nr;
    value3.value = combo[2].nr;

    aic1 = combo[0].aic;
    aic2 = combo[1].aic;
    aic3 = combo[2].aic;

    // remove wenn server aics liefert ;)
    if (val) {
      if (val !== aic1 && val !== aic2 && val !== aic3) {
        val = combo[val];
      }
    }
  }

  currentVal.value = val ?? (column?.meta?.combo ? column?.meta?.combo[0]?.aic : "");
  if (uiData.disabled) {
    disabledText.value = disabledValue();
  }
  initialized = true;
});

function checkChanged(val: any) {
  console.log("radio changed: " + val);
  currentVal.value = val;
  valueChanged(config, uiData, val);
}

function disabledValue(): string {
  // oder welches Mapping wir da später auch brauchen

  const element = config.column!.meta.combo!.find((f: any) => f.aic === currentVal.value);
  if (element && element.bezeichnung) {
    return element.bezeichnung;
  } else {
    return config.column!.meta.combo![currentVal.value]?.bezeichnung;
  }

  return " -- ";
}
function validate() {
  if (uiData.disabled) {
    uiData.errorText = "";
    error = true;
    return true;
  } // disabled Controls sind IMMER valide ;)
  if (uiData.required) {
    if (currentVal) {
      uiData.errorText = "";
      error = true;
      return true;
    }
    uiData.errorText = config.requiredMessage;
    error = true;
    return false;
  }
  uiData.errorText = "";
  return true;
}
</script>
<template>
  <div class="wrap" v-if="uiData.showMutable && initialized">
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <div class="e-float-input" v-bind="props" v-if="!uiData.disabled">
          <span>{{ uiData.description }}</span>

          <v-radio-group
            inline
            ref="radio"
            @update:modelValue="checkChanged"
            :disabled="uiData.disabled"
            :error="error"
            :error-messages="uiData.errorText"
            v-model="currentVal"
            class="pt-0 mt-0"
            :required="uiData.required"
            persistent-hint
            :hint="uiData.hintText"
          >
            <v-radio class="pr-2 ma-0" :value="aic1" color="warning" :label="text1" />
            <v-radio class="pr-2 ma-0" :value="aic2" color="success" :label="text2" />
            <v-radio class="ma-0" :value="aic3" color="red" :label="text3" />
          </v-radio-group>
        </div>

        <div style="text-align: left" v-if="uiData.disabled" class="py-2">
          <span>{{ uiData.description }}: {{ disabledText }}</span>
        </div>
        <ValueChangeTracker v-if="uiData.isChanged || props.disableValueChangeTracker" />
      </template>
    </v-tooltip>
  </div>
</template>

<style scoped>
.radioStyle {
  font-size: 12px;
}
</style>
